import axios from 'axios';
import { CURRENT_HOST } from '../Constants';
import { NavigateFunction } from 'react-router-dom';

export const createAxiosInstance = (history: NavigateFunction, onUnauthorized?: () => void) => {
    const axiosInstance = axios.create({
        baseURL: CURRENT_HOST,
        withCredentials: true,
    });

    axiosInstance.interceptors.response.use(
        response => response,
        error => {
            if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                onUnauthorized?.();
                history('/login');
            }
            return Promise.reject(error);
        }
    );

    return axiosInstance;
};
